import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';
import {
  RECENTLY_VIEWED_COOKIE_NAME,
  RECENTLY_VIEWED_ITEMS_PER_ROW,
  RECENTLY_VIEWED_MAX_ITEMS,
} from './constants';
import { parseRecentlyViewed } from './recentlyViewedCookie';

type UseRecentlyViewedResult = {
  ids: string[];
};

const readIds = (): string[] => {
  const ids = parseRecentlyViewed(Cookie.get(RECENTLY_VIEWED_COOKIE_NAME));
  // Don't show the second row until we have RECENTLY_VIEWED_MAX_ITEMS items
  return ids.length < RECENTLY_VIEWED_MAX_ITEMS
    ? ids.slice(0, RECENTLY_VIEWED_ITEMS_PER_ROW)
    : ids;
};

export const useRecentlyViewed = (): UseRecentlyViewedResult => {
  const [ids, setIds] = useState<string[]>([]);

  useEffect(() => {
    setIds(readIds());

    const refresh = () => {
      if (document.visibilityState === 'visible') {
        setIds(readIds());
      }
    };

    document.addEventListener('visibilitychange', refresh);

    return () => {
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);

  return { ids };
};
